
export { CollectionName } from "/codebuild/output/src4157304699/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"